export default "__VITE_ASSET__5b5408ed__"